import { RelatedToType } from '@shared/enums';

export namespace RelatedToActions {
  export interface RelatedToContext {
    relatedToKey: string;
    relatedToId: number;
    standardRelation?: {
      fieldName?: string;
      between?: {
        mainObject: RelatedToType;
        relatedObject: RelatedToType;
      };
    };
  }

  export class Set {
    static readonly type = '[Jupiter] Set Related To';

    constructor(
      public relatedToKey: RelatedToType | string | number,
      public context?: RelatedToContext,
    ) {}
  }

  export class SetBackUrl {
    static readonly type = '[Jupiter] Set Back Url';

    constructor(public backUrl: string) {}
  }

  export class Clear {
    static readonly type = '[Jupiter] Clear Related To';

    constructor() {}
  }
}
